import { getCurrentInstance } from '@vue/composition-api';

export const useSocket = () => {
    const vm = getCurrentInstance();
    if (!vm) {
        throw new Error('useSocket must be called in setup');
    }
    return vm.proxy.$socket;
};
